<template>
  <div class="w-full px-10 pt-6 pb-5 leading-none border rounded-lg border-polgrey-medium" role="alert">
    <div class="mb-2">
      <h4 class="text-lg font-semibold">
        Representative example:
      </h4>
    </div>
    <p class="text-lg leading-snug">
      Assuming a credit limit of £1,200 and an interest rate on purchases of {{ toFixed(aprRate, 2, true) }}% p.a. variable, you will receive a {{ toFixed(aprRate, 1) }}% APR representative variable.
    </p>
  </div>
</template>

<script>

import mixins from '@/v2/mixins'

export default {
  name: 'RepresentitiveExample',
  mixins: [mixins],
  props: {
    aprRate: Number,
  },
}

</script>
